const e = {
  INSTRUCTOR: {
    id: 1,
    displayName: "Instructor",
    pluralDisplayName: "Instructors",
    roleIconClassName: "instructor",
    avatarColor: "#1D252C",
    description: "Can view/edit data across a single classroom.",
    icon: "fa-light fa-chalkboard-user"
  },
  STUDENT: {
    id: 2,
    displayName: "Trainee",
    pluralDisplayName: "Trainees",
    description: "Works on assigned simulations.",
    icon: "fa-light fa-head-side-goggles"
  },
  MULTI_ORG_ADMIN: {
    id: 6,
    displayName: "Super Admin",
    pluralDisplayName: "Super Admins",
    roleIconClassName: "super-admin",
    avatarColor: "#FFCD00",
    description: "Can view/edit data and manage users across multiple organizations.",
    icon: "fa-light fa-users-gear"
  },
  MULTI_ORG_VIEWER: {
    id: 7,
    displayName: "Reporter",
    pluralDisplayName: "Reporters",
    roleIconClassName: "reporter",
    avatarColor: "#FF8672",
    description: "Can only view data and users across multiple organizations.",
    icon: "fa-light fa-user-lock"
  },
  ORG_ADMIN: {
    id: 8,
    displayName: "Admin",
    pluralDisplayName: "Admins",
    roleIconClassName: "org-admin",
    avatarColor: "#CDDB00",
    description: "Can view/edit data and manage users across a single organization.",
    icon: "fa-light fa-user-gear"
  },
  CS_ADMIN: {
    id: 10,
    displayName: "Admin",
    pluralDisplayName: "Admins",
    roleIconClassName: "cs-admin",
    avatarColor: "#FFCD00"
  },
  CS_MANAGER: {
    id: 11,
    displayName: "Manager",
    pluralDisplayName: "Managers",
    roleIconClassName: "cs-manager",
    avatarColor: "#CDDB00"
  }
}, t = Object.values(e), i = (a = [], s) => a.find((d) => d.id === s), u = (a) => {
  var s;
  return (s = i(t, a)) == null ? void 0 : s.roleIconClassName;
}, C = (a) => {
  var s;
  return (s = i(t, a)) == null ? void 0 : s.avatarColor;
}, R = (a) => {
  var s;
  return (s = i(t, a)) == null ? void 0 : s.displayName;
}, N = (a) => i(t, a), g = () => [
  e.MULTI_ORG_ADMIN,
  e.MULTI_ORG_VIEWER,
  e.ORG_ADMIN,
  e.INSTRUCTOR,
  e.STUDENT
], p = () => [e.ORG_ADMIN, e.INSTRUCTOR, e.STUDENT], c = [
  [e.MULTI_ORG_ADMIN.id, [e.MULTI_ORG_VIEWER]],
  [e.MULTI_ORG_VIEWER.id, [e.MULTI_ORG_ADMIN]],
  [e.INSTRUCTOR.id, [e.ORG_ADMIN]],
  [e.ORG_ADMIN.id, [e.INSTRUCTOR]]
], m = new Map(c), T = (a) => m.get(a.id), r = {
  sky: "#C5D9E7",
  white: "#FFF",
  salmon: "#FF8672",
  darkCherry: "#79242F",
  olive: "#68813C",
  brightGreen: "#CDDB00",
  navy: "#002E6D",
  funBlue: "#00A7E1",
  black: "#1D252C",
  lightGray: "#CFCFCF",
  errorRed: "#D12D00",
  lightRed: "rgba(255, 144, 126, 0.10)",
  offwhite: "#F4F4F4",
  contrastGray: "#727376",
  paleWhite: "rgba(244, 244, 244, 0.30)"
}, l = [
  [r.salmon, r.darkCherry],
  [r.funBlue, r.navy],
  [r.brightGreen, r.olive]
];
function I() {
  const a = Math.floor(Math.random() * l.length);
  return l[a];
}
const o = {
  TS: 1,
  CE: 2,
  TRK: 3
}, n = /* @__PURE__ */ new Map();
n.set(o.TS, {
  id: o.TS,
  name: "TS",
  displayName: "Training Simulations",
  alternateDisplayName: "TS"
});
n.set(o.CE, {
  id: o.CE,
  name: "CE",
  displayName: "Trek (VR)"
});
n.set(o.TRK, {
  id: o.TRK,
  name: "TRK",
  displayName: "Trek (Mobile)",
  alternateDisplayName: "Trek"
});
function D(a) {
  return n.get(a) ?? {};
}
function y(a) {
  return n.get(a).name;
}
function M() {
  return [...n.values()];
}
export {
  t as A,
  r as C,
  o as P,
  e as R,
  u as a,
  D as b,
  C as c,
  N as d,
  g as e,
  p as f,
  R as g,
  i as h,
  c as i,
  m as j,
  T as k,
  I as l,
  y as m,
  M as n
};
